<template>
  <div id="app">
    <!--<img src="./assets/logo.png">-->
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'App',
  created() {
    // 获取 PUSH 权限
    // Push.Permission.request();
    // if(sessionStorage.getItem("loginProjectName"))document.title = sessionStorage.getItem("loginProjectName");
  },
  mounted(){
    sessionStorage.setItem('nowNav','716454599370809344')
    sessionStorage.setItem('nowNavObj',JSON.stringify({resourceId:'716454599370809344',resourceName:'综合管理分析系统'}))
    //本地测试用
           if (process.env.NODE_ENV === 'development') {
            this.login()
        }
  },
  methods:{
          login() {
        let userInfo = {
        //1.51
        // user: "webmaster",
        // pwd:"Ax3df!4n"
        //   user: "rblry1",
        //   pwd:"Bx@2025#Foo"
        //生产
          user: "admin ",
          pwd:"Admin@2025"
        // user: "ljjzqclry",
        // pwd:"Bx@2025#Foo"
        //   user: "JTSHIGS",
        //   pwd:"Zlkj@2025"
        //   user: "pacxlr",
        //   pwd:"Zlkj@2025"
        //   user:"yacxlry",
        //   pwd:"Bx@2025#Foo"
        //   user:"gscxlr",
        //   pwd:"Zlkj@2025"
        };

        this.$axios
          .post("/api/login/check", this.$qs.stringify(userInfo))
          .then(response => {
            localStorage.setItem('Admin-Data', JSON.stringify(response.data.data));
            sessionStorage.setItem('Admin-Data', JSON.stringify(response.data.data));
            // let projectInfo = {
// mainPrjCode: "T40",
// mainPrjName: "项目名称",
// projectId: "324395265299578880",
// projectPlanSn: null,
// projectType: null,
// typeKey: "project_zgs",

// mainPrjCode: "T13",
// mainPrjName: "项目名称",
// projectId: "462831514966851584",
// projectPlanSn: null,
// projectType: "null",
// typeKey: "project_zhb"

    // };
    // let projectInfo ={"projectId":"-1","mainPrjName":"","mainPrjCode":"","mainSectionId":"","mainSectionName":"","mainSectionCode":"","stdVersion":"","sectionMajor":"","projectPlanSn":"","projectType":""}
              let projectInfo={"typeKey":"project_zhb","projectId":"634622440802476032","mainPrjName":"平台","mainPrjCode":"T44","projectPlanSn":null,"projectType":null}
    sessionStorage.setItem("projectInfo",JSON.stringify(projectInfo));
        let arr=[
        {resourceId:'705971034868846592',resourceName:'综合管理分析'},
        {resourceId:'716454599370809344',resourceName:'数据采集填报'},
    ]
    sessionStorage.setItem("projectInfo",JSON.stringify(projectInfo));
    sessionStorage.setItem('allNav',JSON.stringify(arr))
    sessionStorage.setItem('nowNav','705971034868846592')
    sessionStorage.setItem('nowNavObj',JSON.stringify({resourceId:'705971034868846592',resourceName:'综合管理分析系统'}))
          })
          .catch(error => {});
      }

  },
}
</script>

<style lang="less">
#app {
  font-family: 'Arial';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  /*margin-top: 1px;*/
  height: 100%;
}
.el-dialog__wrapper{
  &.dialog-fade-leave-active{
   -ms-animation:none;
 }
}
</style>



// WEBPACK FOOTER //
// src/App.vue